export enum AttachmentContentTypes {
  QuickForm = 'quick_form',
  QuickTestResults = 'quick_test_results',
  QuickFormSubmission = 'form_submission',
  Faq = 'faq',
  SelfScheduler = 'self_scheduler',
  OldSelfScheduler = 'schedule_submission',
  QuickSignDocument = 'quick_sign_document',
}

export enum ConditionalTypes {
  NotEqual = 'Does not equal',
  Equal = 'Equals',
  BoolYes = 'Is Yes',
  BoolNo = 'Is No',
  More = 'Is greater than',
  Less = 'Is less than',
  MoreOr = 'Is greater than or equal to',
  LessOr = 'Is less than or equal to',
}

export enum ConditionalTypeOperators {
  NotEqual = '!=',
  Equal = '==',
  BoolYes = 'true',
  BoolNo = 'false',
  More = '>',
  Less = '<',
  MoreOr = '>=',
  LessOr = '<=',
}

export enum FormSubmissionSourceTypes {
  Self = 'self_requested',
  User = 'user_requested',
  Bot = 'bot_requested',
}

export enum QuickFormFieldTypes {
  AddressField = 'address_field',
  Boolean = 'boolean',
  BloodPressure = 'blood_pressure',
  Checklist = 'checklist',
  Date = 'date',
  DateTime = 'datetime',
  Dosage = 'dosage',
  Email = 'email',
  HtmlSelect = 'html_select',
  frequency = 'frequency',
  HtmlNumber = 'html_number',
  PainScale = 'pain_scale',
  PhoneNumber = 'phone_number',
  RadioButtons = 'radio_buttons',
  Ratings = 'ratings',
  Signature = 'signature',
  Notice = 'notice',
  Markdown = 'markdown',
  HtmlText = 'html_text',
  HtmlTime = 'html_time',
  File = 'file',
  Weight = 'weight',
}

export enum QuickFormConfigValues {
  IsRequired = 'isRequired',
  IsEnabled = 'isEnabled',
  IsRequireAtLeastOne = 'isRequireAtLeastOne',
  IsRequiredAllToBeChecked = 'isRequiredAllToBeChecked',
  IsSelectAllEnabled = 'isSelectAll',
  IsDefaultTrue = 'isDefaultTrue',
  IsNumbers = 'isNumbers',
  IsPrinting = 'isPrinting',
  IsRow = 'isRow',
  IsCustomBp = 'isCustomBp',
  IsMultiple = 'isMultiple',
  IsYearFirst = 'isYearFirst',
  IsAutofill = 'isAutofill',
  Max = 'max',
  Min = 'min',

  IsMaxEnabled = 'isMaxEnabled',
  IsMinEnabled = 'isMinEnabled',
  MinLength = 'minLength',
  IsMinLengthEnabled = 'isMinLengthEnabled',
  MaxLength = 'maxLength',
  IsMaxLengthEnabled = 'isMaxLengthEnabled',
  Hint = 'hint',
  Content = 'content',
  DiastolicValues = 'diastolicValues',
  SystolicValues = 'systolicValues',
  Accept = 'accept',
  Format = 'format',
  FirstDay = 'firstDay',
  Options = 'options',
  OrderType = 'orderType',
}

export enum SubmissionStatus {
  Submited = 1,
  Opened = 2,
  Abandoned = 3,
}

export enum StatusListLabels {
  All = 'all',
  Opened = 'opened',
  Submitted = 'submitted',
  Completed = 'completed',
  Abandoned = 'abandoned',
  Uploaded = 'uploaded',
  UploadFailed = 'Upload Failed',
}
